module.exports = __webpack_public_path__ + "img/video-pic01.01c15d26.png";